// ===== SHARED UI COMPONENTS =====
export const DetailField = ({ label, value, valueColor }) => (
  <div>
    <div
      style={{
        fontSize: "11px",
        fontWeight: 500,
        color: "#94a3b8",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        marginBottom: "2px",
      }}
    >
      {label}
    </div>
    <div style={{ fontSize: "14px", fontWeight: 500, color: valueColor || "#1e293b" }}>
      {value || "--"}
    </div>
  </div>
);

export const ModalOverlay = ({ children, onClose, width = "520px" }) => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0,0,0,0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1050,
      padding: "16px",
    }}
    onClick={(e) => {
      if (e.target === e.currentTarget) onClose();
    }}
  >
    <div
      style={{
        background: "white",
        borderRadius: "12px",
        padding: "26px",
        maxWidth: width,
        width: "100%",
        maxHeight: "92vh",
        overflowY: "auto",
        boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
      }}
    >
      {children}
    </div>
  </div>
);

export const ModalHeader = ({ title, onClose }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "16px",
    }}
  >
    <h3 style={{ margin: 0, fontSize: "1.2rem", fontWeight: 600 }}>{title}</h3>
    <button
      onClick={onClose}
      style={{
        background: "none",
        border: "none",
        fontSize: "22px",
        cursor: "pointer",
        color: "#94a3b8",
        padding: "4px 8px",
        borderRadius: "4px",
      }}
    >
      &times;
    </button>
  </div>
);

export const ModalCloseButton = ({ onClose, label = "Close" }) => (
  <button
    onClick={onClose}
    style={{
      marginTop: "20px",
      width: "100%",
      padding: "10px",
      background: "#f1f5f9",
      border: "1px solid #e2e8f0",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: 500,
      fontSize: "14px",
      color: "#475569",
    }}
  >
    {label}
  </button>
);

export const StatusBadge = ({ isActive, accountStatus }) => {
  const active =
    isActive || String(accountStatus || "").toUpperCase() === "ACTIVE";
  return (
    <span
      className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${
        active ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
      }`}
    >
      {active ? "Active" : "Suspended"}
    </span>
  );
};

export const EmailVerifiedBadge = ({ value }) => {
  const v = Boolean(value);
  return (
    <span
      className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${
        v ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
      }`}
    >
      {v ? "Verified" : "Unverified"}
    </span>
  );
};